export default __webpack_public_path__ + "static/media/remove.f5660af3.svg";